export enum enProductType {
  DIGITAL = 1,
  SERVICE = 2,
  PHYSICAL = 3,
  TICKET = 4,
  ECOMMERCE = 5
}
